import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { mediaQueries } from 'plugins/device'
import { IconLeafMulticolor, colors } from '@blocket/blocket-ui'

const Wrapper = styled.div`
  background-color: ${colors.green50};
  border-radius: 10px;
  overflow: hidden;
  font-size: 13px;
  line-height: 20px;
  display: flex;
  margin-top: 14px;
  @media ${mediaQueries.medium} {
    max-width: 320px;
    margin-top: 0px;
  }
`

const Intro = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
`

const StyledIconLeafMulticolor = styled(IconLeafMulticolor)`
  flex-shrink: 0;
  margin-right: 12px;
`

const SustainabilityInfo = ({ data = {}, children, style, className }) => {
  const co2Text = data.text || ''
  const co2Equivalent = data.equivalent || ''
  const co2Description = `${co2Text} ${co2Equivalent}`

  return (
    <Wrapper style={style} className={className}>
      <Intro>
        <StyledIconLeafMulticolor width={25} height={25} />
        {co2Description}
        {children && <div>{children}</div>}
      </Intro>
    </Wrapper>
  )
}

SustainabilityInfo.propTypes = {
  data: PropTypes.object,
  style: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
}

export default SustainabilityInfo
